<template>
  <div>
    <el-form
      :model="pdiForm"
      :rules="rules"
      ref="pdiFormRef"
      style="width: 100%; margin-top: 20px"
    >
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="1"></el-col>
        <el-col :span="6">
          <el-form-item
            prop="select"
            label="Chr"
            style="margin-bottom: 22px; margin-left: 45px"
          >
            <el-select
              v-model="pdiForm.select"
              placeholder="Please select"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="input1" label="Start" style="width: 100%">
            <el-input v-model="pdiForm.input1" style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <div style="text-align: center; width: 100%; margin-top: 15px">
            &mdash;&mdash;
          </div>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="input2" label="End" style="width: 100%">
            <el-input v-model="pdiForm.input2" style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <!--  -->
      </el-row>
    </el-form>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "pdiComponent",
  props: {
    resetKey: {
      type: String,
      required: true,
    },
  },
  created() {
    console.log(this.resetKey);
    if (this.resetKey) {
      this.resetForm();
      this.seqflag = true;
      if (this.resetKey === "maize") {
        // Handle maize specific logic here
        this.options = this.maizeOptions
      } else if (this.resetKey === "cotton") {
        // Handle cotton specific logic here
        this.options = this.cottonOptions
      } else if (this.resetKey === "wheat") {
        // Handle wheat specific logic here
        this.options = this.wheatOptions
      }
    }
  },
  data() {
    return {
      pdiForm: {
        select: "",
        input1: "",
        input2: "",
      },
      seqflag: false,
      exampleSeq: "",
      options: [
        
      ],
      maizeOptions: [
        {
          value: "01",
          label: "1",
        },
        {
          value: "02",
          label: "2",
        },
        {
          value: "03",
          label: "3",
        },
        {
          value: "04",
          label: "4",
        },
        {
          value: "05",
          label: "5",
        },
        {
          value: "06",
          label: "6",
        },
        {
          value: "07",
          label: "7",
        },
        {
          value: "08",
          label: "8",
        },
        {
          value: "09",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
      ],
      cottonOptions: [
        {
          value: "01",
          label: "1",
        },
        {
          value: "02",
          label: "2",
        },
        {
          value: "03",
          label: "3",
        },
        {
          value: "04",
          label: "4",
        },
        {
          value: "05",
          label: "5",
        },
        {
          value: "06",
          label: "6",
        },
        {
          value: "07",
          label: "7",
        },
        {
          value: "08",
          label: "8",
        },
        {
          value: "09",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
        {
          value: "11",
          label: "11",
        },
        {
          value: "12",
          label: "12",
        },
        {
          value: "13",
          label: "13",
        },
      ],
      wheatOptions: [
        {
          value: "1A",
          label: "1A",
        },
        {
          value: "1B",
          label: "1B",
        },
        {
          value: "1D",
          label: "1D",
        },
        {
          value: "2A",
          label: "2A",
        },
        {
          value: "2B",
          label: "2B",
        },
        {
          value: "2D",
          label: "2D",
        },
        {
          value: "3A",
          label: "3A",
        },
        {
          value: "3B",
          label: "3B",
        },
        {
          value: "3D",
          label: "3D",
        },
        {
          value: "4A",
          label: "4A",
        },
        {
          value: "4B",
          label: "4B",
        },
        {
          value: "4D",
          label: "4D",
        },
        {
          value: "5A",
          label: "5A",
        },
        {
          value: "5B",
          label: "5B",
        },
        {
          value: "5D",
          label: "5D",
        },
        {
          value: "6A",
          label: "6A",
        },
        {
          value: "6B",
          label: "6B",
        },
        {
          value: "6D",
          label: "6D",
        },
        {
          value: "7A",
          label: "7A",
        },
        {
          value: "7B",
          label: "7B",
        },
        {
          value: "7D",
          label: "7D",
        },
      ],
      rules: {
        select: [
          {
            required: true,
            message: "Please select a chromosome",
            trigger: "change",
          },
        ],
        input1: [
          { required: true, message: "Start is required", trigger: "blur" },
          { validator: this.validateStart, trigger: "blur" },
        ],
        input2: [
          { required: true, message: "End is required", trigger: "blur" },
          { validator: this.validateEnd, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    resetForm() {
      this.pdiForm.select = "";
      this.pdiForm.input1 = "";
      this.pdiForm.input2 = "";
    },
    updataEx() {},
    getData() {
      if(this.resetKey === "wheat") {
        let res =
        `chr` +
        this.pdiForm.select +
        `:` +
        this.pdiForm.input1 +
        `-` +
        this.pdiForm.input2;
        return res
      } else {
        let res =
        `Chr` +
        this.pdiForm.select +
        `:` +
        this.pdiForm.input1 +
        `-` +
        this.pdiForm.input2;
        return res
      }
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.pdiFormRef.validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    validateStart(rule, value, callback) {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("Start is required"));
      } else {
        callback();
      }
    },
    validateEnd(rule, value, callback) {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("End is required"));
      } else if (Number(value) < Number(this.pdiForm.input1)) {
        callback(new Error("End must be greater than or equal to Start"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-form-item__label {
  font-size: 18px; /* 调整字号 */
}

.tipsButton {
  display: flex;
  margin: 0 auto;
  margin-top: 17px;
  justify-content: space-evenly;
  align-items: center;
}
</style>
